<template>
  <div style="font-weight: bold;color: black;">
    <p v-if="dataList.length>0">该预算产品下面包含以下关联产品</p>
    <div v-for="(item,index) in dataList" :key="index" style="margin-top: 10px;">
      <el-checkbox v-model="item.isCheck"></el-checkbox>&nbsp;&nbsp;
      <span>{{item.nameCn}}/{{item.price}}{{item.currency}}</span>
    </div>
  </div>
</template>

<script>
import ResourceApi from '@/components/Api/resource.js'
export default {
  data(){
    return{
      dataList:[],
    }
  },
  methods:{
    getDataList(ids){
      new ResourceApi("resource").queryCustomStockReation(ids).then(res => {
        if (res.status == 200) {
          this.dataList = res.data
          console.log('sxxxx',this.dataList)
          this.dataList.forEach(ee=>{
            this.$set(ee,'isCheck',true)
          })
        }
      }).catch(e=>{
        this.$message.error(res.statusText)
      })
    }
  }
}
</script>

<style>

</style>